import { render, staticRenderFns } from "./enviarRelatorioOs.vue?vue&type=template&id=7c34b1d0"
import script from "./enviarRelatorioOs.vue?vue&type=script&lang=js"
export * from "./enviarRelatorioOs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports